import React from 'react';
import WorkerSubTask from './WorkerSubTask.enhancer';
import TaskTitle from './TaskTitle';
import { Typography, Divider } from '@material-ui/core';
import { initPersonaDocument, updatePersonaDocumentsTags, getTaskDescription } from '../../firebase/db';
import { uploadPersonaDocument } from '../../firebase/storage'
import CheckIcon from '@material-ui/icons/CheckOutlined'

class WorkerSubTaskDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subTask: {},
            task: {},
        };
    }

    componentDidMount() {
        const { row } = this.props;
        this.setState({
            subTask: row.subTask
        })
        getTaskDescription(row.subTask.task)
            .then((task) => {
                this.setState({ task: task[0] })
            })
    }

    setSubTask = (subTask) => {
        this.setState({
            subTask
        })
    }

    render() {
        const { row, title, onTagsOpen } = this.props;
        const { subTask, task } = this.state;
        return (
            <div style={{
                padding: 20
            }}>
                <div style={{
                    fontSize: 24,
                    fontWeight: 'bold',
                    paddingLeft: 30
                }}>
                    <Typography variant="title" color="secondary" gutterBottom>{`Project: ${title} | Cycle ${row.cycles.index + 1}: ${row.cycles.title}`}</Typography>
                </div>
                <Divider />
                <div style={{ padding: '30px', display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="title" color="secondary" gutterBottom>{`Task : ${task.name}`}</Typography>

                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '230px', height: '80px', borderLeft: subTask.finished && '10px solid green' || '10px solid #ffff00' }}>
                            <div style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row', marginLeft: 10, width: '160px' }}>
                                <Typography color="secondary" gutterBottom>{`Start  ${row.subTask.startDate && new Date(row.subTask.startDate).toLocaleDateString('de-AT') || ''}`}</Typography>
                                <Typography color="secondary" gutterBottom>{`Ende  ${row.subTask.endDate && new Date(row.subTask.endDate).toLocaleDateString('de-AT') || ''}`}</Typography>
                            </div>
                            {subTask.finished &&
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                    <Typography>erledigt am:</Typography>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <Typography style={{ color: 'green' }}>{new Date(subTask.finishedDate).toLocaleDateString('de-AT')}</Typography>
                                        <CheckIcon style={{
                                            color: 'white', borderRadius: 40,
                                            backgroundColor: 'green',
                                            borderStyle: 'solid',
                                            borderWidth: 1,
                                            borderColor: '#ccc',
                                        }} />
                                    </div>
                                </div>
                            }
                        </div>
                        <TaskTitle task={task} disabled={true} worker={true} />

                        <WorkerSubTask
                            subTask={row.subTask}
                            subTaskId={row.subTaskId}
                            task={task}
                            setSubTask={this.setSubTask}
                            onTagsOpen={onTagsOpen}
                            projectTitle={title}
                            cycleTitle={row.cycles.title}
                            taskId={row.subTask.task}
                            projectId={task.project}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default WorkerSubTaskDetail;


// WEBPACK FOOTER //
// ./src/components/Tasks/WorkerSubTaskDetail.js